const customMediaQuery = (minWidth: number) =>
  `@media (min-width: ${minWidth}px)`;

const media = {
  custom: customMediaQuery,
  md: customMediaQuery(768),
  lg: customMediaQuery(1200),
  xl: customMediaQuery(1600),
};

export default media;
